import { useTranslation } from 'react-i18next';
import { convertSecondsToTime } from 'utils/timeHelper';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { ModuleType } from 'infrastructure/enums';
import type { FC } from 'react';

interface ModuleTimeProps {
  clinicTime?: number;
  totalTime?: number;
  module: ModuleType;
  accent?: boolean;
}

const ModuleTime: FC<ModuleTimeProps> = ({
  clinicTime,
  totalTime,
  module,
  accent,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(s['time-body'], { [s.accent]: accent })}
      data-module={module}
    >
      <div className={s['time-body-item']}>
        <p className={s['time-body-title']}>{t('controls.clinic')}</p>
        <div className={s['time-body-count']} data-cy="clinic-interactive-time">
          {convertSecondsToTime(clinicTime)}
        </div>
      </div>
      <div className={s['time-body-module']}>{module.toUpperCase()}</div>
      <div className={s['time-body-item']}>
        <p
          className={classNames(s['time-body-title'], {
            [s.accent]: accent,
          })}
        >
          {t('controls.total')}{' '}
        </p>
        <div
          className={classNames(s['time-body-count'], {
            [s.accent]: accent,
          })}
          data-cy="total-interactive-time"
        >
          {convertSecondsToTime(totalTime)}
        </div>
      </div>
    </div>
  );
};
export default ModuleTime;
